import SHA256 from 'crypto-js/sha256';
import Hex from 'crypto-js/enc-hex';
import { Message } from './types';

/**
 * Generates a deterministic message ID based on previous messages using a Fiat-Shamir-like approach
 * where the new ID is derived from the hash of all previous messages.
 */
export const generateMessageId = (previousMessages: Message[], content: string, role: string, timestamp: string): string => {
  // Create a string of all previous message IDs, roles, and contents
  let messageString = previousMessages.map(msg => 
    `${msg.id}:${msg.role}:${msg.content}`
  ).join('|');

  // Add the new message to the message string
  messageString += `:${role}:${content}:${timestamp}`;
  
  // Generate a hash
  return SHA256(messageString).toString(Hex);
};
